
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M119.8 159.1C163.1 203 205.6 244 250 286.2c15.1-14.9 29.2-28.6 43.2-42.4 14.7-14.4 29.8-28.5 43.9-43.5 13-13.9 29.9-24.5 42.4-45-85.8 0-167.2 0-248.7.1-2.6.1-5.2 1.7-11 3.7zm258 188.6c-11.6-19.1-65.8-75.2-81.5-84.4l-46.8 45-49.5-48.4c-27 29.6-54.7 56.1-80.5 86.1 4.4 2.5 6.3 4.4 8.1 4.4 81.5.2 163 .2 244.5.1 1.9.1 3.7-1.8 5.7-2.8zm-67.9-98.4l80.6 84.5c2.6-4.4 4.6-6.3 4.6-8.2.3-48.8.3-97.7.2-146.6 0-1.9-2-3.7-4.2-7.6-28.6 24.2-53.2 51-81.2 77.9zm-199.8-77.2l-6.3 2.1c-.1 17.2-.3 34.5-.3 51.8-.1 18.3-.5 36.6.1 54.8.6 16.9-2.7 34.2 3.5 54.3l81.4-85.6-78.4-77.4zM500 500.3H0V.3h500v500z"}})])
          )
        }
      }
    